export default "__VITE_ASSET__CXG31ZwC__"